module.exports = __webpack_public_path__ + "fonts/Monument Extended Regular.fe4ade1.woff";